import React from 'react'

const Ice = () => {
    return (
        <div>Ice</div>
    )
}

export default Ice